export default {
  methods: {
    sendMetaEvent(trackType, eventName, eventData) {
      if (typeof window.fbq !== 'function') {
        return;
      }

      if (typeof eventData === 'undefined') {
        window.fbq(trackType, eventName);
        return;
      }

      window.fbq(trackType, eventName, eventData);
    },
  },
};
